import { strokeWidth } from "apparatus/draw";
import { P, R } from "apparatus/library/common";
import { Path, Shape } from "paper";
export class MicroscopeSlide {
    render(appearance) {
        const { width, height } = appearance;
        if (appearance.side) {
            const graphic = new Path.Line(P(0, 0), P(width, 0));
            graphic.withStroke(strokeWidth("thin"), "#999999aa");
            return {
                graphic: graphic,
                hitShape: graphic.bounds.expand(20).toShape(),
                snapping: [
                    graphic.placeable(),
                ]
            };
        }
        else {
            const graphic = Shape.Rectangle(R(0, 0, width, height));
            graphic.withStroke(strokeWidth("thin"), "#999999aa").withFill("#dddddd40");
            return {
                graphic: graphic,
                hitShape: graphic.bounds.toShape()
            };
        }
    }
}
MicroscopeSlide.properties = {
    label: "Microscope slide",
    defaultAppearance: {
        width: 75,
        height: 25,
        side: false
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "width", label: "Width",
            min: 50, max: 150, unit: "mm"
        },
        {
            spec: "slider", key: "height", label: "Height",
            min: 20, max: 50, unit: "mm"
        },
        {
            spec: "checkbox", key: "side", label: "View from side"
        }
    ],
};
